import React from 'react';
import styles from './ChangeTags.module.scss';
import { SFText } from 'sfui';
import { TagsField } from '../../../App/Main/ReportWizard/FieldInput/TagsField/TagsField';
import { FieldValueType, ReportTags } from '../../../Models';

export interface ChangeTagsProps {
  tags: ReportTags | undefined;
  onTagsChange: (tags: FieldValueType) => void;
}

export const ChangeTags = ({
  tags,
  onTagsChange
}: ChangeTagsProps): React.ReactElement<ChangeTagsProps> => {
  return (
    <div className={styles.changeTags}>
      <SFText type="component-title">Change Tags</SFText>
      <TagsField
        label="Agency Tags"
        value={tags?.agency || []}
        onChange={(v) => onTagsChange(v)}
      />
    </div>
  );
};
